import * as React from 'react'
import MUITypography from '@mui/material/Typography'

const Typography = (props) => <MUITypography {...props} />

export default Typography
